// extracted by mini-css-extract-plugin
export default {"uiModeToggle":"uimodetoggle_uiModeToggle__aUm3k","uiModeBtn":"uimodetoggle_uiModeBtn__N1zEK","uiModeBtnActive":"uimodetoggle_uiModeBtnActive__BMbOc"};